import {Injectable} from '@angular/core';
import {AppConfig} from "../shared/global-variables";

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  private readonly LIGHT_COLOR: string = "#EEEEEE";
  private readonly DARK_COLOR: string = "#333333";


  public adjustTextColor(colorHex): string {
    if (colorHex != null) {
      const colorRgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorHex);

      if (colorRgb) {
        let r = parseInt(colorRgb[1], 16);
        let g = parseInt(colorRgb[2], 16);
        let b = parseInt(colorRgb[3], 16);

        let hsp = Math.sqrt(
          0.299 * (r * r) +
          0.587 * (g * g) +
          0.114 * (b * b)
        );

        return (hsp > 127.5) ? this.DARK_COLOR : this.LIGHT_COLOR;
      }
    }
    return null;
  }

  public getColorMap(map: Map<string, number>): Map<string, string> {
    let colorMap = new Map<string, string>();
    let index = 0;
    for (let [serial] of map) {
      if (index === 10) {
        break;
      }
      colorMap.set(serial, AppConfig.COLORS[index]);
      index++;
    }
    return colorMap;
  }

}
